import * as yup from 'yup';
import { ObjectSchema } from 'yup';

export function buildSchemaFromFields(fields: any[]): ObjectSchema<any> {
  const shape: Record<string, any> = {};

  fields.forEach((f) => {
    let validator: yup.AnySchema;

    switch (f.type) {
      case 'number':
        validator = yup
          .number()
          .transform((value, original) =>
            original === '' || original === null ? null : value
          );
        break;
      case 'date':
        validator = yup.date();
        break;
      case 'dropdown':
        validator = yup.number().nullable();
        break;
      case 'text':
        validator = yup.string();
        break;
      default:
        validator = yup.string();
    }

    if (f.condition) {
      validator = validator.when(Object.keys(f.condition), {
        is: (...values: any[]) => {
          return Object.entries(f.condition).every(
            ([key, value], i) => String(values[i]) === String(value)
          );
        },
        then: (schema) => (f.isRequired ? schema.required() : schema),
        otherwise: (schema) => schema.nullable(),
      });
    } else if (f.isRequired) {
      validator = validator.required();
    }

    shape[f.field] = validator.label(f.label).nullable().default(null);
  });

  return yup.object().shape(shape);
}
